import { render, staticRenderFns } from "./DialogCriarJustificativa.vue?vue&type=template&id=4fdb2587&scoped=true"
import script from "./DialogCriarJustificativa.vue?vue&type=script&lang=js"
export * from "./DialogCriarJustificativa.vue?vue&type=script&lang=js"
import style0 from "./DialogCriarJustificativa.vue?vue&type=style&index=0&id=4fdb2587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb2587",
  null
  
)

export default component.exports